import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=7740914c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7740914c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7740914c')) {
      api.createRecord('7740914c', component.options)
    } else {
      api.reload('7740914c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=7740914c&scoped=true&", function () {
      api.rerender('7740914c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2X2jv0xHzqH3C/JS/comp/Accordion.vue"
export default component.exports